import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PassengerNamePipe } from './passenger-name.pipe';

@NgModule({
  declarations: [PassengerNamePipe],
  imports: [CommonModule],
  exports: [PassengerNamePipe],
})
export class PassengerNameModule {}
